import React, { useEffect, useState, useRef } from 'react';
import { View, Text, StyleSheet, Animated, TouchableOpacity, Linking, Image, ScrollView } from 'react-native';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles
import Sidebar from './sidebar';  // ✅ Import the new Sidebar
import Footer from './footer'; // ✅ Import Footer
import Header from './header'; // ✅ Import Footer


const Culture = ({ navigation }) => {

  const [activeLink, setActiveLink] = useState('Culture');

  const [showSidebar, setShowSidebar] = useState(false);

  const handleLinkPress = (screen) => {
    setShowSidebar(false); // Close sidebar on navigation
    navigation.navigate(screen);
  };

   const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };


  return (
    <View style={styles.pageContainer}>

         {/* Fixed Header */}
      <View style={styles.fixedHeader}>
         <Header onToggleSidebar={toggleSidebar} />
      </View>

      {showSidebar && (
        <Sidebar
          activeLink={activeLink}
          handleLinkPress={handleLinkPress}
          onClose={() => setShowSidebar(false)}
        />
      )}


      {/* Scrollable Content */}
    <ScrollView contentContainerStyle={styles.scrollContainer}>

      {/* Main Content */}
      <View style={styles.mainContent}>
        <Text style={styles.heading}>Our Culture</Text>

       {/* Plain Paragraphs */}
      <View style={styles.paragraphContainer}>
     

        <Text style={styles.paragraph}>
            At IntegrationX, culture drives how we build, collaborate, and grow. As a remote-friendly team, we solve business problems with AI, automation, and seamless integrations. We value experimentation, continuous learning, and diverse perspectives — because every voice matters. Whether you’re an engineer, product thinker, or strategist, your work directly impacts our mission and customers.
          </Text>

      </View>

      
       <View style={styles.imageWrapper}>
        <Image
          source={require('./assets/culture.png')}
          style={styles.storyImage}
          resizeMode="cover"
        />
      </View>
      
      

       <Text style={styles.heading}>What We Value</Text>

       {/* Plain Paragraphs */}
       <View style={[styles.paragraphContainer, {  alignItems: 'center' }]}>
          <Text style={styles.paragraph}>🚀  Innovation over convention</Text>
          <Text style={styles.paragraph}>🤝  Collaboration over silos</Text>
          <Text style={styles.paragraph}>🌍  Purpose over process</Text>
          <Text style={styles.paragraph}>🧠  Curiosity over certainty</Text>
          <Text style={styles.paragraph}>🛠️  Action over analysis-paralysis</Text>
        </View>




        {/* Footer */}
        <Footer navigation={navigation} />

      </View>
      </ScrollView>
    </View>
  );
};

export default Culture;
